export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 border-t border-background-300/20">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div className="lg:col-span-1">
            <span className="text-xl font-heading font-black text-primary-400">91电影</span>
            <p className="text-xs text-foreground-500 mt-3 leading-relaxed">
              91电影在线观看与在线播放直达站，高清流畅免费在线影院，每日更新国产热门大片。无需注册，打开即播，畅享影院级体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-300 mb-4">快速导航</h4>
            <div className="space-y-2">
              <a href="#hero" className="block text-xs text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap">首页</a>
              <a href="#index" className="block text-xs text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap">影片分类</a>
              <a href="#carousel" className="block text-xs text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap">焦点专题</a>
              <a href="#cards" className="block text-xs text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap">精选推荐</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-300 mb-4">服务支持</h4>
            <div className="space-y-2">
              <a href="#faq" className="block text-xs text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap">常见问题</a>
              <a href="#contact" className="block text-xs text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap">联系我们</a>
              <a href="#updates" className="block text-xs text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap">更新动态</a>
              <a href="#about" className="block text-xs text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap">关于我们</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-300 mb-4">合作伙伴</h4>
            <p className="text-xs text-foreground-600 leading-relaxed">
              真诚欢迎优质合作伙伴加入，共同为影迷提供更好的观影服务。合作事宜请通过联系我们页面咨询。
            </p>
          </div>
        </div>

        <div className="border-t border-background-300/20 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-600">
            &copy; 2026 91电影 - 91电影在线观看与在线播放 | 免费高清在线影院速播
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-foreground-600">91电影在线观看</span>
            <span className="text-xs text-foreground-600">91电影在线播放</span>
            <span className="text-xs text-foreground-600">91电影免费在线</span>
          </div>
        </div>
      </div>
    </footer>
  );
}